module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ziefen-2b252bd091bc8133aad6de7b3531b85a.png";